import { BigNumber } from '@ethersproject/bignumber'
import { ethers } from 'ethers'
import { getAddress } from '@ethersproject/address'
import { MYAPIKEY } from '@/config'
import { MainTokenConfig } from '@/config'
export { default as copyHandler } from './copy'
export { getPoolAmount } from './getPoolAmount'
export { default as getTime } from './getTime'
export { default as getWalletBalance } from './getWalletBalance'
export { default as errorHandler } from './errorHandler'
export { logSwapData, logSyncData, logInterFaceTransFer } from './logHandler'
export { default as getImage } from './getImage'
export { default as getTokenInfo } from './getTokenInfo'
export { default as isMainAddress } from './isMainAddress'
export { default as getTokenAmount } from './getTokenAmount'
export { default as batchAirToken } from './batchAirToken'
export { default as approve } from './approve'
export { default as batchAirEth } from './batchAirEth'
export { default as getNodeUrl } from './getNodeUrl'

export const fetcher = (args) => fetch(args).then((res) => res.json())

export const isZero = (hexNumberString: string) => {
  return /^0x0*$/.test(hexNumberString)
}
export const isAddress = (value: any): string | false => {
  try {
    return getAddress(value)
  } catch {
    return false
  }
}


export const addressHand = (address) => {
  if (address) {
    const newAddress = address.slice(0, 4) + '...' + address.slice(-4)
    return newAddress
  }
}

export const currentPriceHandler = (reserve0: BigNumber, reserve1: BigNumber, decimals0: number, decimals1: number) => {
  const ETHAmount = ethers.utils.formatUnits(reserve1, decimals1)
  const TokenAmount = ethers.utils.formatUnits(reserve0, decimals0)
  const ETH = ethers.utils.parseEther(ETHAmount)
  const Token = ethers.utils.parseEther(TokenAmount)
  const price = ETH.mul(ethers.constants.WeiPerEther).div(Token)
  const _price = ethers.utils.formatEther(price)
  return _price
}

export function calculateGasMargin(value: BigNumber, margin = 1000): BigNumber {
  return value.mul(BigNumber.from(10000).add(BigNumber.from(margin))).div(BigNumber.from(10000))
}


export function addPercentage(value: BigNumber, margin: BigNumber): BigNumber {
  return value.mul(BigNumber.from(10000).add(margin)).div(BigNumber.from(10000))
}

export function subPercentage(value: BigNumber, margin: BigNumber): BigNumber {
  const fz = (BigNumber.from(10000).sub(margin)).mul(ethers.constants.WeiPerEther)
  const fm = BigNumber.from(10000)
  return value.mul(fz.div(fm)).div(ethers.constants.WeiPerEther)
}


export const getRandomNumber = (minValue: string, maxValue: string, decimals: number) => {
  const BASE = ethers.constants.WeiPerEther
  const min = ethers.utils.parseUnits(minValue, decimals)
  const max = ethers.utils.parseUnits(maxValue, decimals)
  const difference = max.sub(min)
  const rendom = Math.random()
  const buyValue_ = difference.mul(ethers.utils.parseEther(rendom.toString())).div(BASE)
  const _value = min.add(buyValue_)

  return _value
}

export const getETHSwapForTokenAmount = (oldPoolBNBAmount: BigNumber, oldPoolTokenAmount: BigNumber, buyValue: BigNumber) => {
  const K = oldPoolBNBAmount.mul(oldPoolTokenAmount)
  const newPoolBNBAmount = oldPoolBNBAmount.add(buyValue)
  const newPoolTokenAmount = K.div(newPoolBNBAmount)
  const getTokenAmount = oldPoolTokenAmount.sub(newPoolTokenAmount)

  return getTokenAmount
}


export const getBNBBalanceforMultiple = (...address: string[]) => {
  const api = `https://api-testnet.bscscan.com/api?module=account&action=balancemulti&address=${address}&tag=latest&apikey=${MYAPIKEY}`
  return api
}

// 合约ABI
export const getContractABIByAddress = (address: string) => {
  const api = `https://api-testnet.bscscan.com/api?module=contract&action=getabi&address=${address}&apikey=${MYAPIKEY}`
  return api
}
// 合约信息
export const getContractVerifiedCode = (address: string) => {
  const api = `https://api-testnet.bscscan.com/api?module=contract&action=getsourcecode&address=${address}&apikey=${MYAPIKEY}`
  return api
}
// BNB最新价格
export const getBNBLastPrice = () => {
  const api = `https://api.bscscan.com/api?module=stats&action=bnbprice&apikey=${MYAPIKEY}`
  return api
}

export const currentSafeGas = () => {
  const api = `https://api.bscscan.com/api?module=gastracker&action=gasoracle&apikey=${MYAPIKEY}`
  return api
}

export function createPromise() {
  let resolve, reject
  const promise: any = new Promise((_resolve, _reject) => {
    resolve = _resolve
    reject = _reject
  })

  promise.resolve = resolve
  promise.reject = reject

  return promise
}

/**
 * //两个数之间随机整数 含最大值，含最小值
 * @param min 
 * @param max 
 * @returns number 类型
 */
export function getRandomIntInclusive(min: number, max: number) {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export const getOnGasFee = (result: any) => {
  const gasPrice_: ethers.BigNumber = result.effectiveGasPrice
  const useGas: ethers.BigNumber = result.gasUsed
  const gasFee: ethers.BigNumber = gasPrice_.mul(useGas)
  const fee = ethers.utils.formatEther(gasFee)
  return fee
}

export const isBNBHandler = (token: string, chainId: number) => {
  const chain = MainTokenConfig[chainId][0].address
  return token == chain ? true : false
}

// 验证输入是否是数字
// 默认只允许整数，allowDecimal=true 时允许小数
export function isIntegerInput(input: string, allowDecimal = false) {
  if (input === null || input === undefined || input.trim() === '') {
    return true // 输入过程中允许为空
  }

  const str = input.trim()
  if (allowDecimal) {
    // 允许小数：可以是整数或带小数点的数字，但必须至少有一个数字
    return /^-?\d+(\.\d*)?$/.test(str)
  } else {
    // 只允许整数
    return /^-?\d*$/.test(str)
  }
}